/**
 * Drag-to-spin 360 viewer for tire PDP spin_frames metafield.
 */
(function () {
  var root = document.getElementById('tire-pdp-360');
  var viewer = document.getElementById('tire-pdp-360-viewer');
  var frameEl = document.getElementById('tire-pdp-360-frame');
  var dataEl = document.getElementById('tire-pdp-360-frames');
  if (!root || !viewer || !frameEl || !dataEl) return;

  var frames = [];
  try {
    frames = JSON.parse(dataEl.textContent);
  } catch (e) {
    return;
  }
  if (!frames.length) return;

  var index = 0;
  var dragging = false;
  var startX = 0;
  var startIndex = 0;
  var pixelsPerFrame = 12;

  function showFrame(i) {
    index = ((i % frames.length) + frames.length) % frames.length;
    frameEl.src = frames[index];
  }

  function onPointerDown(e) {
    dragging = true;
    startX = e.clientX != null ? e.clientX : e.touches[0].clientX;
    startIndex = index;
    viewer.setPointerCapture && viewer.setPointerCapture(e.pointerId);
  }

  function onPointerMove(e) {
    if (!dragging) return;
    var x = e.clientX != null ? e.clientX : e.touches && e.touches[0] ? e.touches[0].clientX : startX;
    var delta = Math.round((x - startX) / pixelsPerFrame);
    showFrame(startIndex - delta);
  }

  function onPointerUp() {
    dragging = false;
  }

  viewer.style.touchAction = 'none';
  viewer.addEventListener('pointerdown', onPointerDown);
  viewer.addEventListener('pointermove', onPointerMove);
  viewer.addEventListener('pointerup', onPointerUp);
  viewer.addEventListener('pointerleave', onPointerUp);

  viewer.addEventListener('keydown', function (e) {
    if (e.key === 'ArrowLeft') {
      showFrame(index - 1);
      e.preventDefault();
    } else if (e.key === 'ArrowRight') {
      showFrame(index + 1);
      e.preventDefault();
    }
  });
})();
